import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-15',
  templateUrl: './15.component.html',
})
export class VbGeneral15Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
